// extracted by mini-css-extract-plugin
module.exports = {"cost-saving-H":"H_cost-saving-H__uxMYL"};